import {
  useCallback,
  useState,
} from 'react';

export type AddressLookupResult = {
  zipCode: string;
  street: string;
  neighborhood: string;
  city: string;
  state: string;
  provider: string;
};

type AddressLookupResponse = {
  success?: boolean;
  error?: string;

  address?:
    AddressLookupResult;
};

export function useAddressLookup() {
  const [
    isLookingUpAddress,
    setIsLookingUpAddress,
  ] =
    useState(
      false
    );

  const lookupAddress =
    useCallback(
      async (
        zipCode:
          string
      ) => {
        setIsLookingUpAddress(
          true
        );

        try {
          const response =
            await fetch(
              `/api/address-lookup?zipCode=${encodeURIComponent(
                zipCode
              )}`,
              {
                method:
                  'GET',

                headers: {
                  Accept:
                    'application/json',
                },
              }
            );

          const data =
            await response
              .json() as
                AddressLookupResponse;

          if (
            !response.ok ||
            !data.success ||
            !data.address
          ) {
            throw new Error(
              data.error ||
              'Não foi possível consultar o CEP.'
            );
          }

          return data.address;
        } finally {
          setIsLookingUpAddress(
            false
          );
        }
      },
      []
    );

  return {
    lookupAddress,
    isLookingUpAddress,
  };
}